
(function roleModifyControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleCloneController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminRoleService', 'authExtend',
            function roleModifyController($scope, config, $state, $translate, $stateParams, errors, adminRoleService, authExtend) {
                $scope.title = 'RoleCloneFrom';

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                adminRoleService.getById($stateParams.id).then(function (result) {
                    $scope.role = result;
                }, function (error) {
                    errors.showError(error);
                    $state.go('role-find');
                });

                $scope.cancel = function () {
                    $state.go('role-find');
                };

                $scope.save = function () {
                    if (!$scope.roleForm.$valid) {
                        errors.showError('VerifyFormData');
                        $scope.roleForm.$setSubmitted();
                        return false;
                    }

                    $scope.role.name = $scope.roleName;

                    return adminRoleService.clone($scope.role).then(function () {
                        errors.showSuccess('RoleCloneSucess');
                        $state.go('role-find', { id: $scope.role.id });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };
            }
        ]);
})();